import { createAction, props } from '@ngrx/store';
import { IRoutineTemplate } from '../../interfaces/routine.interfaces';

export const getRoutineTemplates = createAction(
	'[Routines] Get Routine Templates',
	props<{ silent: boolean }>()
);

export const setRoutineTemplates = createAction(
	'[Routines] Set Routine Templates',
	props<{ routineTemplates: IRoutineTemplate[] }>()
);

export const editRoutineTemplate = createAction(
	'[Routines] Edit Routine Template',
	props<{ routineTemplate: Partial<IRoutineTemplate> }>()
);

export const filterRoutineTemplates = createAction(
	'[Routines] Filter Routine Templates',
	props<{ searchTerm?: string; category?: string; priority?: string }>()
);

export const deleteRoutineTemplate = createAction(
	'[Routines] Delete Routine Template',
	props<{ pk: string }>()
);
